import {getKeyTransformData} from "@helpers/transform/transform";

export function searchFn<T = unknown>({data, searchValue, searchKey = 'name' as keyof T}: {
    data: T[],
    searchValue: string,
    searchKey?: keyof T | (keyof T)[]
}) {

    if (!searchValue) {
        return data;
    }
    if (data.length === 0 || !data) {
        return []
    }

    let searchData: T[] = [];

    const search = (key: string, searchValue: string, elem: T) => {
        if (!searchValue || !key) {
            return
        }
        if (key?.toString().toLowerCase()?.indexOf(searchValue.trim()?.toString().toLowerCase()) != -1) {
            searchData.push(elem);
            return true
        }
        return false;
    }

    data.forEach(function (elem) {
        if (Array.isArray(searchKey)) {
            for (const key in searchKey) {
                if (searchKey.hasOwnProperty(key)) {
                    const item = searchKey[key]
                    const currentKey = elem[item as keyof T];
                    const hasValue = search(currentKey as string, searchValue, elem);
                    if (hasValue) {
                        break
                    }
                }
            }
            return
        }

        const transformSearchKey = getKeyTransformData(searchKey as string);

        if (elem[transformSearchKey as keyof T]) {
            search(elem[transformSearchKey as keyof T] as string, searchValue, elem)
        } else {
            const key = elem[searchKey as keyof T];
            if (!key) {
                return
            }
            search(key as string, searchValue, elem)
        }

    });
    return searchData

}